import { useState } from "react";
import { useSelector } from "react-redux";
import HomeProductCard from "../../../product-card-home/HomeProductCard";
import styles from "./ProductSection.module.scss";
import HomeHeroCardImage from "../../../../assets/images/pages/home/hero-section/homeheroCard.jpeg";
import Button from "../../../shared/Button/MainButton";
import { RootState } from "../../../../redux/store";
import { useMostSeller } from "../../../../hooks/useHomeQueries";

const ProductSection = () => {
  const [moreProduct, setMoreProduct] = useState(12);

  const selectedLanguage = useSelector(
    (state: RootState) => state.language.selectedLanguage?.code
  );
  const translations = useSelector(
    (state: RootState) => state.translations.data
  );

  const { data: mostSellerResponse, isLoading: loading, isError } = useMostSeller(selectedLanguage);
  
  const bestSelData = mostSellerResponse?.status && Array.isArray(mostSellerResponse.data)
    ? mostSellerResponse.data
    : [];
  const error = isError ? "Network error" : null;

  const handleMoreData = () => {
    if (moreProduct >= bestSelData.length) {
      setMoreProduct(12);
    } else {
      setMoreProduct(moreProduct + 8);
    }
  };

  return (
    <section className={styles.productSection}>
      <div className="container">
        {/* Başlıq Hissəsi Skeletonu */}
        <div className={styles.titleContent}>
          {loading ? (
            <>
              <div className={styles.skeletonText}></div>
              <div className={styles.skeletonTitle}></div>
            </>
          ) : (
            <>
              <p className={styles.text}>{translations.most_sells_products}</p>
              <h2 className={styles.title}>{translations.products}</h2>
            </>
          )}
        </div>

        {/* Kartlar Hissəsi Skeletonu */}
        <div className={styles.cardBox}>
          {loading ? (
            Array(12)
              .fill(0)
              .map((_, index) => (
                <div key={index} className={styles.skeletonCard}></div>
              ))
          ) : error ? (
            <p className={styles.errorText}>{error}</p>
          ) : bestSelData.length > 0 ? (
            bestSelData
              .slice(0, moreProduct)
              .map((product: any, index: number) => (
                <HomeProductCard
                  key={index}
                  productId={product.id}
                  image={product.cover_image || HomeHeroCardImage}
                  title={product.name}
                  discount_percentage={product.discount_percentage}
                  discount_price={product.discount_price}
                  price={product.price}
                  discount={product.discount_price}
                  buttonText={translations.add_to_basket}
                  wishlistStatus={product.wishlist_status}
                  isNew={product.is_new}
                  slug={product.slug}
                />
              ))
          ) : (
            <p>{translations.no_products}</p>
          )}
        </div>

        {/* Daha çox düyməsi */}
        {!loading && bestSelData.length > 12 && (
          <div className={styles.more_btn}>
            <Button
              text={`${
                moreProduct >= bestSelData.length
                  ? translations?.show_less
                  : translations?.show_more
              }`}
              onClick={handleMoreData}
            />
          </div>
        )}
      </div>
    </section>
  );
};

export default ProductSection;
